const KAMServicing = [
  {
    icon: "business",
    name: "Servicing",
    to: "/",
  },
  {
    icon: "description",
    name: "Reports",
    to: "/reports",
  },
];

const NavLinkList = [
  {
    icon: "apps",
    name: "Dashboard",
    to: "/dashboard",
  },

  {
    icon: "description",
    name: "Reports",
    to: "/new-reports",
  },
  {
    icon: "business",
    name: "Admin",
    to: "/admin",
  },
  {
    icon: "local_phone",
    name: "Calls",
    to: "/calls",
  },
  {
    icon: "perm_identity",
    name: "People",
    to: "/field-force",
  },
  {
    icon: "contact_mail",
    name: "User",
    to: "/user",
  },
  {
    icon: "store",
    name: "Outlets",
    to: "/outlets",
  },
  {
    icon: "assignment_ind",
    name: "Face matching",
    to: "/face-matching",
  },
  // {
  //   icon: "track_changes",
  //   name: "KYC",
  //   to: "/kyc",
  // },
];

const NavLinkList_area_manager = [
  {
    icon: "apps",
    name: "Dashboard",
    to: "/dashboard",
  },

  {
    icon: "description",
    name: "Reports",
    to: "/new-reports",
  },
  // {
  //   icon: "local_phone",
  //   name: "Calls",
  //   to: "/calls",
  // },
  {
    icon: "upload",
    name: "Upload",
    to: "/new-uploads",
  },
  {
    icon: "contact_mail",
    name: "User",
    to: "/user",
  },
  {
    icon: "local_phone",
    name: "Calls",
    to: "/calls",
  },
  {
    icon: "business",
    name: "Admin",
    to: "/admin",
  },
  {
    icon: "perm_identity",
    name: "People",
    to: "/field-force",
  },

  {
    icon: "store",
    name: "Outlets",
    to: "/outlets",
  },
  {
    icon: "assignment_ind",
    name: "Face matching",
    to: "/face-matching",
  },
  // {
  //   icon: "track_changes",
  //   name: "KYC",
  //   to: "/kyc",
  // },
];
const NavLinkList_territory_manager = [
  {
    icon: "apps",
    name: "Dashboard",
    to: "/dashboard",
  },

  {
    icon: "description",
    name: "Reports",
    to: "/new-reports",
  },
  {
    icon: "local_phone",
    name: "Calls",
    to: "/calls",
  },
  {
    icon: "store",
    name: "Outlets",
    to: "/outlets",
  },
  {
    icon: "upload",
    name: "Upload",
    to: "/new-uploads",
  },
  {
    icon: "business",
    name: "Admin",
    to: "/admin",
  },
  {
    icon: "perm_identity",
    name: "People",
    to: "/field-force",
  },
  {
    icon: "contact_mail",
    name: "User",
    to: "/user",
  },
  {
    icon: "people",
    name: "Leaderboard",
    to: "/leaderboard",
  },
  // {
  //   icon: "track_changes",
  //   name: "KYC",
  //   to: "/kyc",
  // },
  {
    icon: "swap_calls",
    name: "Routes",
    to: "/route-management",
  },
  {
    icon: "assignment_ind",
    name: "Face matching",
    to: "/face-matching",
  },
];

const NavKAMList = [
  {
    icon: "apps",
    name: "Dashboard",
    to: "/dashboard",
  },
  {
    icon: "code",
    name: "Transfers",
    to: "/transfers",
  },

  {
    icon: "description",
    name: "Reports",
    to: "/new-reports",
  },
  {
    icon: "local_phone",
    name: "Calls",
    to: "/calls",
  },
  {
    icon: "store",
    name: "Outlets",
    to: "/outlets",
  },
  {
    icon: "perm_identity",
    name: "People",
    to: "/field-force",
  },
];

const NavLinkList__super_user = [
  {
    icon: "apps",
    name: "Dashboard",
    to: "/dashboard",
  },
  {
    icon: "description",
    name: "Reports",
    to: "/new-reports",
  },
  {
    icon: "local_phone",
    name: "Calls",
    to: "/calls",
  },
  {
    icon: "perm_identity",
    name: "People",
    to: "/field-force",
  },
  {
    icon: "store",
    name: "Outlets",
    to: "/outlets",
  },
  {
    icon: "upload",
    name: "Upload",
    to: "/new-uploads",
  },
  // {
  //   icon: "track_changes",
  //   name: "KYC",
  //   to: "/kyc",
  // },
  {
    icon: "assignment",
    name: "e-KYC",
    to: "/ekyc",
  },
  {
    icon: "business",
    name: "Admin",
    to: "/admin",
  },
  {
    icon: "contact_mail",
    name: "User",
    to: "/user",
  },
  {
    icon: "people",
    name: "Leaderboard",
    to: "/leaderboard",
  },
  {
    icon: "swap_calls",
    name: "Routes",
    to: "/route-management",
  },
  {
    icon: "assignment_ind",
    name: "Face matching",
    to: "/face-matching",
  },
];

const NavLinkList__online_user = [
  {
    icon: "apps",
    name: "Dashboard",
    to: "/dashboard",
  },
  {
    icon: "store",
    name: "Outlets",
    to: "/outlets",
  },
  {
    icon: "description",
    name: "Reports",
    to: "/new-reports",
  },

  {
    icon: "upload",
    name: "Upload",
    to: "/new-uploads",
  },

  {
    icon: "business",
    name: "Admin",
    to: "/admin",
  },
];

const NavLinkList__cluster_manager = [
  {
    icon: "apps",
    name: "Dashboard",
    to: "/dashboard",
  },
  {
    icon: "description",
    name: "Reports",
    to: "/new-reports",
  },
  {
    icon: "local_phone",
    name: "Calls",
    to: "/calls",
  },
  {
    icon: "store",
    name: "Outlets",
    to: "/outlets",
  },
  // {
  //   icon: "track_changes",
  //   name: "KYC",
  //   to: "/kyc",
  // },
  {
    icon: "perm_identity",
    name: "People",
    to: "/field-force",
  },
];

const NavLinkList__agency_manager = [
  {
    icon: "apps",
    name: "Dashboard",
    to: "/dashboard",
  },
  {
    icon: "description",
    name: "Reports",
    to: "/new-reports",
  },
  {
    icon: "local_phone",
    name: "Calls",
    to: "/calls",
  },
  {
    icon: "store",
    name: "Outlets",
    to: "/outlets",
  },
  {
    icon: "business",
    name: "Admin",
    to: "/admin",
  },
  // {
  //   icon: "track_changes",
  //   name: "KYC",
  //   to: "/kyc",
  // },
  {
    icon: "swap_calls",
    name: "Routes",
    to: "/route-management",
  },
  {
    icon: "perm_identity",
    name: "People",
    to: "/field-force",
  },
  {
    icon: "assignment_ind",
    name: "Face matching",
    to: "/face-matching",
  },
];

const NavLinkList__QC = [
  // {
  //   icon: "track_changes",
  //   name: "KYC",
  //   to: "/kyc",
  // },
];

export {
  KAMServicing,
  NavLinkList,
  NavLinkList_area_manager,
  NavLinkList_territory_manager,
  NavKAMList,
  NavLinkList__super_user,
  NavLinkList__online_user,
  NavLinkList__cluster_manager,
  NavLinkList__agency_manager,
  NavLinkList__QC,
};
